import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Pagination, TableWrapper, commonFilterMeta } from '../../Common/Table/types';
import Table from '../../Common/Table/Table';
import PaginationMobile from '../../../../../pages/Responsive/PaginationMobile';
import useGetNewProjectData from '../../../hooks/useGetNewProjectData';
import { RootState } from '../../../../../redux/root';
import { headers } from '../Documents/DocumentsTable';
import useOnCommonTableActivity from '../../../hooks/useOnCommonTableActivity';
import useStatusFilter from '../../../hooks/useStatusFilter';
import { getCustomActivities } from '../../../../../api/activities';
import { InspectionItemType } from '../../../types';
import { setPermitConditions, setPermitConditionsLoading, setSelectedCondition } from '../../../../../redux/slices/conditionsSlice';

const ConditionsTable = () => {
  useGetNewProjectData({ conditions: true });
  const dispatch = useDispatch();
  const conditionDocumentsList = useSelector((s: RootState) => s.conditions.AllPermitsWithConditions);
  const conditionsLoading = useSelector((s: RootState) => s.conditions.conditionsLoading);
  const { filteredRows, withStatusFilter } = useStatusFilter(conditionDocumentsList);
  const { visibleItems } = useOnCommonTableActivity(filteredRows);
  const onConditionSelected = item => {
    onConditionSelectedWithDispatch(item, dispatch);
  };

  return (
    <TableWrapper>
      <Table
        collection={visibleItems}
        headers={withStatusFilter(headers)}
        filterMeta={commonFilterMeta}
        gridTemplateCols="1fr 1fr 138px 138px 90px"
        setSelectedItemInSlice={onConditionSelected}
        isLoading={conditionsLoading}
      />
      <Pagination>
        <PaginationMobile showEverywhere />
      </Pagination>
    </TableWrapper>
  );
};

export default ConditionsTable;

export const onConditionSelectedWithDispatch = async (item, dispatch) => {
  dispatch(setPermitConditions([]));
  dispatch(setPermitConditionsLoading(true));
  dispatch(setSelectedCondition(item));
  const params = {
    is_deleted: false,
    limit: 1000000,
    offset: 0,
    permit_id: item.permitId,
    event_type: 'Activity',
    activity_type_name: 'Conditions',
  };
  try {
    const payload = await getCustomActivities(params);
    const { results } = payload.data;
    dispatch(setPermitConditions(results));
  } catch (e) {
    dispatch(setPermitConditionsLoading(false));
  }
};
